import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // eslint-disable-next-line no-console
  console.warn('Supabase env vars are missing. Auth features will be disabled.');
}

// Singleton, hard-guarded on `globalThis`. Two problems this protects
// against:
//   • Vite/CRA HMR re-executing this module during dev, which would
//     otherwise create a brand-new client on every code save.
//   • Duplicate copies of the module ending up in the bundle (rare, but
//     possible with chunk splitting) — each copy would call
//     `createClient` again and issue its own token refresh on the next
//     fetch, producing the classic user_projects → refresh → user_projects
//     loop that ends in a Supabase 429.
// Exactly ONE client instance for the lifetime of the tab.
const GLOBAL_KEY = '__yb_supabase_client__';

export const supabase =
  globalThis[GLOBAL_KEY] ||
  (globalThis[GLOBAL_KEY] = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }));

// Session Storage key used to carry the hero prompt through the signup flow.
export const PENDING_PROMPT_KEY = 'yb_pending_prompt';
